(function () {
  var suppressDrawerUntil = 0;
  var drawerPatched = false;
  var drawerRefreshing = false;

  function patchCartDrawer() {
    if (drawerPatched) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;

    var originalOpen = drawer.open.bind(drawer);
    drawer.open = function (opener) {
      if (Date.now() < suppressDrawerUntil) return;
      originalOpen(opener);
    };
    drawerPatched = true;
  }

  function findProductImage(productForm) {
    var scope = productForm.closest('.shopify-section') || document;
    return scope.querySelector(
      '.ocean-main-image, .product__media-item.is-active img, .product__media img, .card__media img, .media img'
    );
  }

  function animateImageToCart(productForm) {
    var image = findProductImage(productForm);
    var cartIcon = document.querySelector('#cart-icon-bubble');
    var submitButton = productForm.querySelector('[type="submit"][name="add"], .ocean-add-btn');
    if (!image || !cartIcon || !image.getBoundingClientRect) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var imageRect = image.getBoundingClientRect();
    var cartRect = cartIcon.getBoundingClientRect();
    var imageIsVisible = imageRect.bottom > 0 && imageRect.top < window.innerHeight;
    var cartIsVisible = cartRect.bottom > 0 && cartRect.top < window.innerHeight;
    var sourceRect = imageIsVisible || !submitButton ? imageRect : submitButton.getBoundingClientRect();
    var targetCenterX = cartIsVisible ? cartRect.left + cartRect.width / 2 : window.innerWidth - 28;
    var targetCenterY = cartIsVisible ? cartRect.top + cartRect.height / 2 : 28;
    if (!sourceRect.width) return;

    var size = Math.min(92, Math.max(56, sourceRect.width * 0.22));
    var sourceCenterX = sourceRect.left + sourceRect.width / 2;
    var sourceCenterY = sourceRect.top + sourceRect.height / 2;
    var flyer = document.createElement('div');
    flyer.className = 'cart-add-flyer';
    var flyerImage = image.cloneNode(true);
    flyerImage.removeAttribute('id');
    flyer.appendChild(flyerImage);
    flyer.style.width = size + 'px';
    flyer.style.height = size + 'px';
    flyer.style.left = sourceCenterX - size / 2 + 'px';
    flyer.style.top = sourceCenterY - size / 2 + 'px';
    document.body.appendChild(flyer);

    var endX = targetCenterX - sourceCenterX;
    var endY = targetCenterY - sourceCenterY;
    var animation = flyer.animate(
      [
        { transform: 'translate(0, 0) scale(0.65)', opacity: 0 },
        { transform: 'translate(0, -16px) scale(1.08)', opacity: 1, offset: 0.18 },
        { transform: 'translate(' + endX * 0.45 + 'px, ' + (endY * 0.35 - 60) + 'px) scale(0.82)', opacity: 0.96, offset: 0.65 },
        { transform: 'translate(' + endX + 'px, ' + endY + 'px) scale(0.18)', opacity: 0.2 }
      ],
      { duration: 1000, easing: 'cubic-bezier(.22,.75,.28,1)' }
    );

    animation.onfinish = function () {
      flyer.remove();
      cartIcon.classList.remove('cart-add-icon-success');
      void cartIcon.offsetWidth;
      cartIcon.classList.add('cart-add-icon-success');
      window.setTimeout(function () {
        cartIcon.classList.remove('cart-add-icon-success');
      }, 700);
    };
  }

  function showAddedConfirmation(text, isError) {
    var existing = document.querySelector('.cart-add-confirmation');
    if (existing) existing.remove();

    var message = document.createElement('div');
    message.className = 'cart-add-confirmation' + (isError ? ' cart-add-confirmation--error' : '');
    message.setAttribute('role', 'status');
    message.textContent = text || '✓ Added to cart';
    document.body.appendChild(message);
    window.setTimeout(function () {
      message.remove();
    }, 1900);
  }

  function addOceanProductWithoutRedirect(form, submitButton) {
    if (submitButton.disabled) return;

    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
    animateImageToCart(form);
    submitButton.classList.remove('cart-add-success');
    void submitButton.offsetWidth;
    submitButton.classList.add('cart-add-success');

    var formData = new FormData(form);
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (section) { return section.id; })
      : ['cart-icon-bubble'];

    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw new Error(data.description || 'Unable to add this item.');
          return data;
        });
      })
      .then(function (data) {
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data, true);
        } else if (data.sections && data.sections['cart-icon-bubble']) {
          var parser = new DOMParser();
          var parsed = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var currentBubble = document.querySelector('#cart-icon-bubble');
          var nextBubble = parsed.querySelector('#cart-icon-bubble');
          if (currentBubble && nextBubble) currentBubble.innerHTML = nextBubble.innerHTML;
        }
        showAddedConfirmation('✓ Added to cart');
      })
      .catch(function (error) {
        showAddedConfirmation(error.message || 'Unable to add this item.', true);
      })
      .finally(function () {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        window.setTimeout(function () {
          submitButton.classList.remove('cart-add-success');
        }, 500);
      });
  }

  function refreshAndOpenCartDrawer(trigger) {
    if (drawerRefreshing) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.open !== 'function') {
      window.location.href = window.routes ? window.routes.cart_url : '/cart';
      return;
    }

    drawerRefreshing = true;
    trigger.setAttribute('aria-busy', 'true');
    var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var separator = rootUrl.indexOf('?') === -1 ? '?' : '&';

    fetch(rootUrl + separator + 'sections=cart-drawer,cart-icon-bubble', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart.');
        return response.json();
      })
      .then(function (sections) {
        if (!sections['cart-drawer']) throw new Error('Cart drawer section is unavailable.');

        suppressDrawerUntil = 0;
        drawer.renderContents({ sections: sections }, true);
        drawer.open(trigger);
      })
      .catch(function () {
        window.location.href = window.routes ? window.routes.cart_url : '/cart';
      })
      .finally(function () {
        drawerRefreshing = false;
        trigger.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('#cart-icon-bubble');
    if (!trigger || !document.querySelector('cart-drawer')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    refreshAndOpenCartDrawer(trigger);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var submitButton = event.submitter || form.querySelector('[type="submit"][name="add"]');
    if (form.matches('.ocean-product-form') && submitButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      addOceanProductWithoutRedirect(form, submitButton);
      return;
    }

    var productForm = form.closest('product-form');
    if (!productForm || !submitButton || submitButton.dataset.skipCartButton === 'true') return;
    if (form.querySelector('[name="id"][data-skip-cart="true"]')) return;

    suppressDrawerUntil = Date.now() + 4000;
    patchCartDrawer();
    animateImageToCart(productForm);
    submitButton.classList.remove('cart-add-success');
    void submitButton.offsetWidth;
    submitButton.classList.add('cart-add-success');
    window.setTimeout(function () {
      submitButton.classList.remove('cart-add-success');
      var errorMessage = productForm.querySelector('.product-form__error-message-wrapper:not([hidden])');
      if (!errorMessage) showAddedConfirmation('✓ Added to cart');
    }, 800);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCartDrawer);
  } else {
    patchCartDrawer();
  }
})();
